import { useState, useCallback, useRef, useEffect } from 'react';
import moment from 'moment';

export default function useAfterTypingSubmit({ onSubmit, debounce }) {
  const [typingTime, setTypingTime] = useState(0);
  const [typing, setTyping] = useState(false);

  const handleKeyDown = useCallback(event => {
    if (event.key !== 'Enter') {
      setTyping(true);
      setTypingTime(moment().valueOf());
    }
  }, []);

  const timer = useRef();

  const handleTick = useCallback(() => {
    if (moment().valueOf() - typingTime > 500) {
      onSubmit();
      setTyping(false);
      setTypingTime(0);
    }
  }, [typingTime, onSubmit]);

  const scheduleTick = useCallback(() => {
    const timeOutId = setTimeout(() => {
      handleTick();
      scheduleTick();
    }, debounce);
    timer.current = timeOutId;
  }, [handleTick, debounce]);

  // eslint-disable-next-line consistent-return
  useEffect(() => {
    if (typing) scheduleTick();
    if (timer.current) return () => clearTimeout(timer.current);
  }, [scheduleTick, typing]);

  return { onKeyDown: handleKeyDown };
}
